/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Errordescription2Inputs */

const en_signin_errordescription2 = /** @type {(inputs: Signin_Errordescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred. Please ask the reception to send you a new link.`)
};

const fr_signin_errordescription2 = /** @type {(inputs: Signin_Errordescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur s'est produite. Veuillez demander à la réception de vous envoyer un nouveau lien.`)
};

/**
* | output |
* | --- |
* | "An error occurred. Please ask the reception to send you a new link." |
*
* @param {Signin_Errordescription2Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const signin_errordescription2 = /** @type {((inputs?: Signin_Errordescription2Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Errordescription2Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signin_errordescription2(inputs)
	return fr_signin_errordescription2(inputs)
});
export { signin_errordescription2 as "signIn_errorDescription" }